import ga from './ga-init';

const loadAnalytics = () => {
    ga.initGoogleAnalytics();
};

export default loadAnalytics;